import { ExposureConfig } from '../../ExposuresConfiguration/types';
import { useGet } from '../../../../api';

const ENDPOINT = '/insights/configurations';

const useGetExposuresConfigurations = () => {
    const { data, fetchData, error, loading } = useGet<ExposureConfig[]>({
        url: ENDPOINT
    });
    return { exposuresConfigurations: data, isFetching: loading, error, refetch: fetchData };
};

export default useGetExposuresConfigurations;
